import script from "./FormTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./FormTextarea.vue?vue&type=style&index=0&id=e77cde92&scoped=true&lang=css"

import exportComponent from "/Users/nana/LFMG/ionic-apps/vxt-ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e77cde92"]])

export default __exports__